<template>
  <v-dialog v-model="showDialog" persistent width="620" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="dark">
        <v-btn icon dark @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Recipient</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="save">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <el-form label-position="top" label-width="100px" @submit.native.prevent>
          <el-form-item label="Name">
            <el-input v-model="form.firstname"></el-input>
          </el-form-item>
          <el-form-item label="Mobile">
            <el-input v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="Email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
        </el-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../services";

export default {
  name: "recipient-dialog",
  props: {
    showDialog: { default: false }
  },
  data() {
    return {
      form: {
        firstname: "",
        mobile: "",
        email: ""
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.form);
    }
  }
};
</script>